import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { userloginDetails } from "../Utils/AdminAuth";
import { HOST_URL, NODE_HOST_URL } from "../Dashboard/api/Api";
import ReactTooltip from "react-tooltip";
import { FiInfo } from "react-icons/fi";
import { getData } from "country-list";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Axios from "../../axios/Axios";


const AddAgentCoupon = () => {
  const { id } = useParams();

  const lStorage = userloginDetails();

  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const adminType = lStorage?.user?.isAdmin;

  const [formData, setFormData] = useState({
    code: "",
    discountType: "percentage",
    currency: "INR",
    discountValue: "",
    minPurchaseAmount: "",
    minDiscountAmount: "",
    expiryDate: null,
    usageLimit: "",
    isUserSpecific: false,
    users: [],
    status: "active",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [userList, setUserList] = useState([]);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [bgColor, setBgColor] = useState("");
  const [activeInfo, setActiveInfo] = useState(null);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const toggleUser = (userId) => {
    setFormData((prev) => {
      const exists = prev.users.includes(userId);

      return {
        ...prev,
        users: exists
          ? prev.users.filter((id) => id !== userId)
          : [...prev.users, userId],
      };
    });
  };

  const expiryDateHandler = (date) => {
    setFormData((prev) => ({
      ...prev,
      expiryDate: date,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const payload = {
        user_id: userId,
        token: userToken,
        method: id ? "update" : "create",

        code: formData.code.trim(),
        discount_type: formData.discountType,

        currency:
          formData.discountType === "flat"
            ? formData.currency
            : "",

        discount_value: Number(formData.discountValue),

        expiry_date: new Date(formData.expiryDate).toISOString(),
        usage_limit: Number(formData.usageLimit),

        is_user_specific: formData.isUserSpecific,

        allowed_users: formData.isUserSpecific
          ? formData.users
          : [],

        is_active: formData.status === "active",
      };

      if (id) {
        payload.id = id;
      }
      const response = await Axios.post(`${NODE_HOST_URL}/admin/coupon`, payload);
      const result = response.data;

      if (result.success === true) {

        setSuccessMessage(true);
        setBgColor("alert alert-success alert-dismissible");
        setErrorMessage(result.message);
      }
      else {
        setSuccessMessage(true);
        setBgColor("alert alert-danger alert-dismissible");
        setErrorMessage(result.message);
      }
    }
    catch (error) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Something went wrong!");
    }

  }

  const validateForm = () => {
    const newErrors = {};

    if (!formData.code.trim()) newErrors.code = "Coupon code is required";
    if (!formData.discountType) newErrors.discountType = "Discount type is required";
    if (!formData.discountValue) newErrors.discountValue = "Discount value is required";
    if (!formData.expiryDate) newErrors.expiryDate = "Expiry date is required";
    if (!formData.usageLimit) newErrors.usageLimit = "Usage limit is required";
    if (!formData.status) newErrors.status = "Status is required";

    if (formData.discountType === "flat" && !formData.currency) {
      newErrors.currency = "Currency is required";
    }

    if (formData.isUserSpecific && formData.users.length === 0) {
      newErrors.users = "Please select at least one user";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchCouponDetail = async (id) => {
    // Reset old alerts
    setSuccessMessage(false);
    setErrorMessage("");
    setBgColor("");

    try {
      const payload = {
        user_id: userId,
        token: userToken,
        method: "retrieve_dtl",
        id,
      };

      const response = await Axios.post(
        `${NODE_HOST_URL}/admin/coupon`,
        payload
      );

      const result = response.data;

      if (result.success) {
        const data = result.data;

        setFormData({
          code: data.code || "",
          discountType: data.discount_type || "percentage",
          currency: data.currency || "INR",
          discountValue: data.discount_value || "",
          minPurchaseAmount: data.min_purchase_amount || "",
          minDiscountAmount: data.min_discount_amount || "",
          // 
          expiryDate: data.expiry_date ? new Date(data.expiry_date) : null,
          usageLimit: data.usage_limit || "",
          isUserSpecific: data.is_user_specific === true,
          users: data.allowed_users || [],
          status: data.is_active ? "active" : "inactive",
        });
      } else {
        setSuccessMessage(true);
        setBgColor("alert alert-danger alert-dismissible");
        setErrorMessage(result.message);
      }
    } catch (error) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Something went wrong!");
    }
  };

  useEffect(() => {
    if (id) {
      fetchCouponDetail(id);
    }
  }, [id]);

  useEffect(() => {
    if (formData.isUserSpecific) {
      fetchUsers();
    }
  }, [formData.isUserSpecific]);

  const fetchUsers = async () => {
    try {
      const res = await Axios.post(`${HOST_URL}/admin_user_list.php`, {
        user_id: userId,
        token: userToken,
        method: "retrieve_all_user",
        type: adminType,
      });

      if (res.data.success) {
        setUserList(res.data.data);

      }
    } catch (err) {
      console.error("Failed to load users");
    }
  };

  const filteredUsers = userList.filter((u) =>
    u.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

 const InfoLabel = ({ text, info, id, required }) => (
  <label className="form-label d-flex align-items-center gap-3">
    {text}

    {required && <span className="text-danger">*</span>}

    <FiInfo
      size={12}
      className="text-muted"
      data-tip
      data-for={id}
      data-event="click"
      style={{ cursor: "pointer" }}
    />

    <ReactTooltip
      id={id}
      place="right"
      effect="solid"
      globalEventOff="click"
      clickable
    >
      {info}
    </ReactTooltip>
  </label>
);



  return (
    <div className="wrapper">
      <AdminLeftMenu />

      <div className="main">
        <AdminHeader />

        <main className="content">
          <div className="container-fluid p-0">

            <div className="row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <h3>
                  <strong>Agent Coupon</strong>
                </h3>
              </div>
            </div>
            {successMessage && (
              <div className={bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div>{errorMessage}</div>
              </div>
            )}


            <div className="card p-4">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  {/* Code */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Coupon Code"
                      info="Unique code users will enter to receive the discount."
                      id="couponCodeInfo"
                      required
                    />

                    <input
                      type="text"
                      name="code"
                      className="form-control"
                      value={formData.code}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Discount Type */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Discount Type"
                      info="Choose percentage for % discount or flat for fixed currency discount."
                      id="discountTypeInfo"
                      required
                    />

                    <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                      <div className="input-group mb-2 mr-sm-2 ">

                        <select
                          name="discountType"
                          onChange={handleChange}
                          value={formData.discountType}
                          className="form-control"
                        >

                          <option value="percentage">Percentage</option>
                          <option value="flat">Flat</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* Currency (only if flat) */}
                  {formData.discountType === "flat" && (
                    <div className="col-md-6 mb-3">
                      <InfoLabel
                        text="Currency"
                        info="Currency applied when using flat discount type."
                        id="currencyInfo"
                        required={formData.discountType === "flat"}
                      />

                      <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                        <div className="input-group mb-2 mr-sm-2 ">

                          <select
                            name="currency"
                            className="form-control"
                            value={formData.currency}
                            onChange={handleChange}
                          >

                            <option value="INR">INR</option>
                            <option value="USD">USD</option>
                            <option value="EUR">EUR</option>
                          </select>
                        </div>
                      </div>
                    </div>

                  )}

                  {/* Discount Value */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Discount Value"
                      info="Percentage or fixed amount deducted from the total price."
                      id="discountValueInfo"
                      required
                    />

                    <input
                      type="number"
                      name="discountValue"
                      className="form-control"
                      value={formData.discountValue}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Minimum Purchase */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Minimum Purchase Amount"
                      info="Minimum order value required for this coupon to apply."
                      id="minPurchaseInfo"
                    />

                    <input
                      type="number"
                      name="minPurchaseAmount"
                      className="form-control"
                      value={formData.minPurchaseAmount}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Minimum Discount */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Minimum Discount Amount"
                      info="Lowest discount value that will be granted after calculation."
                      id="minDiscountInfo"
                    />

                    <input
                      type="number"
                      name="minDiscountAmount"
                      className="form-control"
                      value={formData.minDiscountAmount}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Validity"
                      info="Expiry date after which the coupon can no longer be used."
                      id="validityInfo"
                      required
                    />

                    <div className="input-group">
                      <div className="input-group-text">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                      </div>

                      <div style={{ flex: 1 }}>
                        <ReactDatePicker
                          className="form-control btn-block"
                          dateFormat="yyyy-MM-dd"
                          selected={formData.expiryDate}
                          onChange={expiryDateHandler}
                          placeholderText="Select expiry date"
                          minDate={new Date()}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Usage Limit */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Usage Limit"
                      info="Maximum number of times this coupon can be used across all users."
                      id="usageLimitInfo"
                      required
                    />

                    <input
                      type="number"
                      name="usageLimit"
                      className="form-control"
                      value={formData.usageLimit}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* User Specific */}
                  <div className="col-md-6 mb-3">
                    <div className="form-check mt-4">
                      <input
                        type="checkbox"
                        name="isUserSpecific"
                        className="form-check-input"
                        checked={formData.isUserSpecific}
                        onChange={handleChange}
                      />
                      <InfoLabel
                        text="Is User Specific"
                        info="Restrict this coupon so only selected users can use it."
                        id="userSpecificInfo"
                      />

                    </div>
                  </div>

                  {/* User List */}
                  {formData.isUserSpecific && (
                    <div className="col-md-6 mb-3">
                      <InfoLabel
                        text="Select Users"
                        info="Choose the users who are allowed to use this coupon."
                        id="selectUsersInfo"
                        required={formData.isUserSpecific}
                      />


                      <div className="position-relative">
                        {/* Dropdown trigger */}
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowUserDropdown((v) => !v)}
                        >
                          <span className="text-muted drop-down-icons mb-2 mr-sm-2 table1">
                            {formData.users.length
                              ? `${formData.users.length} user(s) selected`
                              : "Select Users"}
                          </span>


                        </div>

                        {/* Dropdown menu */}
                        {showUserDropdown && (
                          <div
                            className="position-absolute bg-white border rounded w-100 mt-1"
                            style={{
                              zIndex: 1000,
                              maxHeight: 260,
                              overflowY: "auto",
                            }}
                          >
                            {/* Search input */}
                            <div className="p-2 border-bottom">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Search user by email..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>

                            {/* Empty state */}
                            {filteredUsers.length === 0 && (
                              <div className="p-2 text-muted small">
                                No users found
                              </div>
                            )}

                            {/* User list */}
                            {filteredUsers.map((u) => (
                              <label
                                key={u.id}
                                className="d-flex align-items-center gap-2 px-3 py-2 mb-0"
                                style={{ cursor: "pointer" }}
                              >
                                <input
                                  type="checkbox"
                                  checked={formData.users.includes(u.id)}
                                  onChange={() => toggleUser(u.id)}
                                />
                                <span>{u.email}</span>
                              </label>
                            ))}
                          </div>
                        )}

                      </div>
                    </div>
                  )}


                  {/* Status */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Status"
                      info="Active coupons can be used by users. Inactive coupons are disabled."
                      id="statusInfo"
                      required
                    />

                    <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                      <div className="input-group mb-2 mr-sm-2 ">

                        <select
                          name="status"
                          className="form-control"
                          value={formData.status}
                          onChange={handleChange}
                        >

                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>

                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button type="submit" className="btn btn-primary">
                    {id ? "Update Coupon" : "Create Coupon"}
                  </button>
                </div>
              </form>

            </div>

          </div>
        </main>

        <AdminFooter />
      </div>
    </div>
  );
};

export default AddAgentCoupon;
